var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4395 0.574158C26.0721 0.206699 25.5745 0 25.0539 0H7.18588C3.21784 0 0 3.21784 0 7.18588V42.8141C0 46.7822 3.21784 50 7.18588 50H32.377C36.345 50 39.5628 46.7822 39.5628 42.8141V14.5096C39.5628 13.989 39.3536 13.4914 38.9861 13.124L26.4395 0.574158ZM30.3055 40.4231H9.25803C8.17609 40.4231 7.29824 39.5453 7.29824 38.4633C7.29824 37.3814 8.17609 36.5036 9.25803 36.5036H30.3055C31.3874 36.5036 32.2653 37.3814 32.2653 38.4633C32.2653 39.5453 31.3874 40.4231 30.3055 40.4231ZM9.25803 32.3952H30.3055C31.3874 32.3952 32.2653 31.5173 32.2653 30.4354C32.2653 29.3535 31.3874 28.4756 30.3055 28.4756H9.25803C8.17609 28.4756 7.29824 29.3535 7.29824 30.4354C7.29824 31.5173 8.17609 32.3952 9.25803 32.3952ZM30.3055 24.3673H9.25803C8.17609 24.3673 7.29824 23.4894 7.29824 22.4075C7.29824 21.3255 8.17609 20.4477 9.25803 20.4477H30.3055C31.3874 20.4477 32.2653 21.3255 32.2653 22.4075C32.2653 23.4894 31.3874 24.3673 30.3055 24.3673ZM27.0392 6.709L27.0418 12.5628L32.9186 12.5884L27.0392 6.709Z",
    fill: "grey"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a7b5f3b501ce268370874994fb694aeb.svg";
export { ForwardRef as ReactComponent };